<template>
  <div>
   <policy v-if="setForm" :dialog="setForm" :data="editedPolicy" :videoIDs="videoIDs" @onChange="createPolicy" @closed="closePolicy" @close="closePolicy"/>
   <delete v-if="onDeleteDialog" :dialog="onDeleteDialog" :title="'Delete Policy'" :message="'Are you sure you want to delete this policy?'" :id="deleteID" @onChange="deleteConfirmation" @close="closeDelete"/>
   <attestation v-if="onAttest" :dialog="onAttest" :isAttested="isAttested" :data="attestItem" @onChange="attestConfirmation" @closed="closeAttest" @close="closeAttest"/>

   <div class="mt-5 pt-4">
     <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
       <ol class="breadcrumb">
         <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Policies</strong></li>
         <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Policy Compliance</li>
       </ol>
     </nav>


     <div class="mt-4">
       <div class="row">
         <div class="col-md-12">


         <div class="card shadow p-3 mb-5 bg-white rounded border-0">
           <div class="card-body m-2">
               <div class="row p-2">
                 <div class="row align-items-center">

                   <div class="col-6 col-md-6 col-xl-3">
                     <div class="input-group">
                         <input type="text" class="form-control" placeholder="Search Policies..." aria-label="Username" v-model="search" aria-describedby="search" style="box-sizing: border-box; width: 331px; height: 40px; border: 1px solid #D9D9D9; border-radius: 20px; padding-left: 40px;">
                         <span class="input-group-addon" style="position: absolute; left: 20px; top: 50%; transform: translateY(-50%); background-color: white;">
                           <i class="fas fa-search"></i>
                         </span>
                       </div>
                   </div>

                   <div class="col-6 col-md-6 col-xl-3 col-xxl-2 mt-2 mb-2">
                     <!-- <button v-if="isAdmin || isSuperAdmin" type="button" class="btn btn-primary btn-create" @click="openPolicy" ata-bs-placement="top">Add New Policy</button> -->
                   </div>

                   <!-- FILTERS -->
                   <div class="filter-options-wrapper col-12 col-xl-6 col-xxl-7 d-flex mt-2 mb-2">

                     <div class="d-flex flex-row align-items-center">

                       <span class="p-2 filter-title">
                         <i class="filter-icon fa-solid fa-sort"></i>
                         <span class="filter-text"> Sort </span>
                       </span>
                       <select v-model="selectedSort" class="form-select shadow-none filter-options" style="width:auto;border:none">
                         <option v-for="sortOption in sortByList" :value="sortOption.value" :key="sortOption.value">{{ sortOption.text }}</option>
                       </select>
                     </div>

                     <div class="d-flex flex-row align-items-center">
                       <span class="p-2 filter-title">
                           <i class="filter-icon fa-solid fa-list-ol"></i>
                           <span class="filter-text"> Items per page </span>
                       </span>
                       <select v-model="pagination.pageSize" class="form-select form-select-sm shadow-none filter-options">
                           <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}</option>
                       </select>
                     </div>

                     <div class="d-flex flex-row align-items-center p-1 ms-2">
                       <div class="align-middle col-xs-12">
                         <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                           <!-- <button type="button" class="btn btn-square btn-labeled" :class="view.list ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.list" @click="view.list = !view.list, view.grid = !view.list" v-tooltip.top="'Switch to List View'"><span class="btn-label"><i class="fas fa-list"></i></span></button> -->
                           <!-- <button type="button" class="btn btn-square btn-labeled" :class="view.grid ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.grid" @click="view.grid = !view.grid, view.list = !view.grid" v-tooltip.top="'Switch to Tile View'"><span class="btn-label"><i class="fas fa-border-all"></i></span></button> -->
                         </div>
                       </div>
                     </div>

                   </div>
                   <!-- END -- FILTERS -->

                 </div>

               </div>
                 <div class="row mt-2">
                   <div v-if="loading" class="text-center align-middle">
                     <img src="@/assets/img/loading.svg">
                   </div>

                   <div v-if="!loading" >
                     <div style="overflow: auto !important">
                       <!-- list view -->
                       <table class="table align-middle main-table">
                         <thead>
                           <tr class="table-light text-default">
                             <th v-for="header in filteredHeaders" :key="header.value" v-show="header.show || header.show === undefined" :style="{ 'vertical-align': 'top', 'width': header.width || 'auto', 'text-align': header.align || 'left' }">
                               {{ header.text }}
                             </th>
                           </tr>
                         </thead>
                         <tbody v-if="!policies || policies.length == 0" class="text-center pa-5">
                             <tr>
                               <td colspan="7">
                                   No records to display.
                               </td>
                             </tr>
                         </tbody>

                         <tbody class="align-middle text-default" v-for="(policy, index) in policies" :key="index">
                           <tr>
                             <td style="width:15%;" >
                               <span>{{ policy.name }}</span>
                             </td>
                             <td style="width:5%;">{{ policy.version }}</td>
                           <td v-show="!isSuperAdmin" style="width:10%;" :class="{ 'text-success': policy.attested.attested, 'text-warning': policy.required && !policy.attested.attested, 'text-secondary': !policy.required && !policy.attested.attested }">
                            {{ policy.attested.attested ? 'Attested' : (policy.required ? 'Pending' : 'Not Required') }}
                          </td>

                             <td style="width:10%;" v-show="!isSuperAdmin">{{formatDate(policy.attested.date_attested)}}</td>

                             <td style="width:5%;" v-show="!isSuperAdmin">
                               <button type="button" class="btn btn-default custom-icon-btn ms-2" :class="getButtonClass(policy)" ms-1 v-tooltip.top="getAttestationTooltip(policy)" @click="setAttestation(policy)" :disabled="!policy.required && !policy.attested.attested">
                                 <svg width="25" height="27" viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                   <path d="M20.3753 12.9048V5.4631C20.3754 5.36912 20.3566 5.27606 20.32 5.18924C20.2835 5.10242 20.2298 5.02355 20.1622 4.95714L16.3501 1.20952C16.214 1.07553 16.0293 1.00017 15.8366 1H1.72657C1.53387 1 1.34907 1.07525 1.21281 1.20921C1.07655 1.34316 1 1.52485 1 1.71429V24.0952C1 24.2847 1.07655 24.4664 1.21281 24.6003C1.34907 24.7343 1.53387 24.8095 1.72657 24.8095H11.8986M5.84383 10.5238H15.5315M5.84383 5.7619H10.6877M5.84383 15.2857H9.4767" :stroke="getSvgStrokeColor(policy)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                   <path d="M15.5315 1V5.04762C15.5315 5.23706 15.608 5.41874 15.7443 5.5527C15.8805 5.68665 16.0653 5.7619 16.258 5.7619H20.3753M20.3656 16.625L23.4608 17.3976C23.7829 17.4786 24.0094 17.7667 23.9997 18.0929C23.7914 24.9476 19.7698 26 19.7698 26C19.7698 26 15.7482 24.9476 15.5399 18.0929C15.5362 17.9341 15.5875 17.7787 15.6854 17.6524C15.7834 17.526 15.9221 17.4362 16.0788 17.3976L19.174 16.625C19.5652 16.5274 19.9745 16.5274 20.3656 16.625Z" :stroke="getSvgStrokeColor(policy)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                 </svg>
                                 <span v-if="!policy.pdf_exists && !isAdmin" class="position-absolute top-0 start-100
                                     translate-middle">
                                     <span class="fas fa-info-circle"></span>
                                     <span class="visually-hidden">pdf error/deleted</span>
                                 </span>
                               </button>

                                <button type="button" class="btn btn-circle ms-1" @click="handleLinkClick(policy)" v-tooltip.top="'Show policy'">
                                  <i class="fa fa-file-contract"></i>
                                </button>
                             </td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>

             <!-- START -- PAGINATION -->
               <div class="row text-center pt-3 pb-3">

                 <div class="d-inline pagination">
                   <a @click="previousPage()" style="margin-right: 8px; color: #00a0c1;"
                       :style="this.pagination.page == 1 ? 'color: #ccc;' : 'cursor: pointer;'"
                       :disabled="this.pagination.page == 1">
                       <i class="fa fa-chevron-left"></i>
                   </a>
                   <span>
                       <strong>
                         <span> {{ paginationLabel }} of {{ this.pagination.totalItems }} </span>
                       </strong>
                   </span>
                   <a @click="nextPage()" style="margin-left: 8px; color: #00a0c1;" :style="this.pagination.page == this.pagination.totalPages
                       || this.pagination.totalItems == 0 ? 'color: #ccc;' : 'cursor: pointer;'"
                       :disabled="this.pagination.page == this.pagination.totalPages || this.pagination.totalItems == 0">
                       <i class="fa fa-chevron-right"></i>
                   </a>
                 </div>

               </div>
             <!-- END -- PAGINATION -->

           </div>





         </div>

         </div>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import moment from "moment";
import Delete from '@/components/Delete.vue';
import { debounce } from '@/plugins/helper.js'
import Policy from '@/components/policies/Policy.vue';
import Attestation from '@/components/policies/Attestation.vue';

export default{
 name: "PolicyLibrary",

 components: {
   Policy,
   Delete,
   Attestation
 },

 data(){
   return {
     loading: false,
     isEditing: false,
     onDeleteDialog: false,
     deleteID: 0,
     onAttest: false,
     attestItem: [],
     isAttested: false,
     editedPolicy: null,
     headers: [
       { text: "Policy Name", value: "policy", width: "15%" },
       { text: "Version", value: "version", width: "5%" },
       { text: "Attestation Status", value: "attestationStatus", width: "10%" },
       { text: "Attestation Date", value: "attestationDate", width: "10%" },
       { text: "Attest", value: "attest", width: "5px" },
     ],
     search: '',
     policies: [],
     setForm: false,
     videoIDs: [],
     videos: [],


     orgID: this.$helper.setOrganisationID(),
     isAdmin: false,
     isSuperAdmin: this.$store.state.auth.isSuperAdmin,
     policyID: null,
     pagination: {
       pageSize: 10,
       page: 1,
       totalItems: 0,
       totalPages: 1,
     },
     rowsPerPageList: [
       { text: "5", value: 5 },
       { text: "10", value: 10 },
       { text: "20", value: 20 },
     ],
     sortBy: {
       field: "name",
       order: "asc"
     },
     sortByList: [
       { text: "Name: A-Z", value: "name_asc", show: true },
       { text: "Name: Z-A", value: "name_desc", show: true},
       { text: "Attested Date: Newest", value: "attested_desc", show: true },
       { text: "Attested Date: Oldest", value: "attested_asc" , show: true },
       { text: "Date Created: Newest", value: "created_desc", show: true },
       { text: "Date Created: Oldest", value: "created_asc", show: true },
     ],
   }
 },

 async created(){
   this.isAdmin = this.$helper.trainingAdmin();
   this.headers = this.updatedHeaders;
   this.sortByList = this.filteredSortByList

   await this.init();
 },

 //get timezone to pass in backend
//  mounted() {
//   const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

//  },

 methods: {
   async init() {
    //determine if user is vertex analyst
    if (this.$helper.isVertexAnalyst()) {
      this.orgID  = this.$store.state.auth.jwtPayload.organisation_role[0].organisation_id
    }

    await this.getData();

    await this.getOrganisationVideos();
    this.clearInvalidTrainingVideos()

   },

   async getData() {

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
     let params = {
       filter: this.search,
       sort:   this.sortBy.field,
       order: this.sortBy.order,
       limit: this.pagination.pageSize,
       page: this.pagination.page,
       timezone: userTimeZone,
     }


     if (!this.isEditing)
       this.loading = true;

     try {
       const url = '/trainings/organisations/' + this.orgID + '/users/'+this.$store.state.auth.jwtPayload.user_id+'/training-policy/attested';
       const response = await this.$axios.get(url, {params});

       if (response.data.success) {
         this.policies = response.data.training_policies;

         this.pagination.totalItems = response.data.total
         this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)

       } else {
         this.$toast.error(response.data.message);
       }
     } catch (error) {
       console.error('Error:', error);
       // Handle the error appropriately
      //  this.$toast.error('An error occurred while fetching data.');
     }

     this.loading = false;
     this.isEditing = false;
   },

   async getOrganisationVideos() {
     try {
       let url = '/trainings/organisations/' + this.orgID + '/videos';
       const response = await this.$axios.get(url);

       if (response.data.success) {
         this.videos = response.data.assigned_org_videos;
         this.mapVideosToDropdown();
       } else {
         this.$toast.error(response.data.message);
       }

     } catch (error) {
        console.error('Error:', error);
        // this.$toast.error('An error occurred while fetching data.');
     }
   },

   async setRequirement(policy) {
     this.isEditing = true;
     let data = {
       required: policy.required,
     };

     try {
       const response = await this.$axios.put("/orgadmin/trainings/organisations/" + this.orgID + "/training-policy" + "/" + policy.ID + "/requirement", data);

       if (response.data.success) {
         this.$toast.success(response.data.message);
         this.getData();
       } else {
         this.$toast.error(response.data.message);
       }
     } catch (error) {
       console.error("Error updating policy:", error);
     }
   },

   editPolicy(policy){
     this.isEditing = true;
     this.editedPolicy = policy;
     this.setForm = true;
   },

   formatDate(date){
     if (!date) return ""

     return moment(date).format("DD-MMM-YYYY")
   },

   mapVideosToDropdown() {
     this.videoIDs = this.videos
       .filter(video => video.is_active)
       .map(video => ({
         label: video.training_video.name,
         value: video.training_video_id
       }));
   },

   clearInvalidTrainingVideos() {
     this.loading = true
     // Create a set of valid video IDs for quick lookup
     const validVideoIDs = new Set(this.videoIDs.map(video => video.value));

     // Iterate over each policy and clear training_videos if training_video_id is not valid
     this.policies.forEach(policy => {
       if (!validVideoIDs.has(policy.training_video_id)) {
         policy.training_videos = [];
       }
     });

     this.loading = false
   },

   async createPolicy(val){

     let formData = new FormData();

     if (val.data.type == "file"){
       formData.append('file', val.data.file.files);
     }
     else {
       if (val.data.link !== val.data.currLink) {
         formData.append('file', val.data.file);
       }
     }

     formData.append('training_video_id',  val.data.videoID);
     formData.append('required',  val.data.compulsory);
     formData.append('version',  val.data.version);
     formData.append('name',  val.data.name);
     formData.append('type',  val.data.type);


     if (this.isEditing) {
       await this.$axios.put("/orgadmin/trainings/organisations/"+ this.orgID +"/training-policy/"+ val.data.id, formData)
       .then((response) => {
           if (response.data.success){
             this.$toast.success(response.data.message)
             this.getData();
           } else {
             this.$toast.error(response.data.message)
           }
       })
       .catch()
     } else {
       await this.$axios.post("/orgadmin/trainings/organisations/"+ this.orgID +"/training-policy", formData)
       .then((response) => {
           if (response.data.success){
             this.$toast.success(response.data.message)
             this.getData();
           } else {
             this.$toast.error(response.data.message)
           }
       })
       .catch()
     }


   },

   async policyStatusChange(policyID, trainingVideoID) {
     this.isEditing = true;
     let data = {
       training_video_id: trainingVideoID,
     };

     try {
       const response = await this.$axios.put("/orgadmin/trainings/organisations/" + this.orgID + "/training-policy" + "/" + policyID + "/link", data);

       if (response.data.success) {
         this.$toast.success(response.data.message);
         this.getData();
       } else {
         this.$toast.error(response.data.message);
       }
     } catch (error) {
       console.error("Error updating policy:", error);
     }

     this.policyID = null;
   },

  getButtonClass(policy) {
     if (policy.attested.attested) {
       return 'btn-circle-active';
     } else if (!policy.required) {
       return 'btn-circle-inactive';
     } else {
       return 'btn-circle-pending';
     }
   },

   getSvgStrokeColor(policy) {
     if (policy.attested.attested) {
       return '#00B972';
     } else if (!policy.required) {
       return '#bebebe';
     } else {
       return '#FFC107';
     }
   },

   onDelete(policy){
     this.deleteID = policy.ID
     this.onDeleteDialog = true;
   },

   closeDelete() {
     this.deleteID = 0;
     this.onDeleteDialog = false;
   },

   deleteConfirmation(data){
     this.$axios.delete('/orgadmin/trainings/organisations/'+ this.orgID +'/training-policy/'+ data.id)
       .then((response) => {
           if (response.data.success){
               this.$toast.success(response.data.message);
               this.getData();
           } else {
               this.$toast.error(response.data.message);
           }

         this.onDeleteDialog = false;
         this.deleteID = 0;
       })
     .catch()
   },

   setAttestation(item) {

     if (item.attested.attested == true)
     this.isAttested = true;

     if (!item.pdf_exists) {
       if (this.isAdmin) {
         this.$toast.error("Policy file is not available. Please re-upload the file.")
         return
       } else {
         this.$toast.error("Policy file is not available. Please contact your organisation admin.")
         return
       }
     }

     //pop-up attestation with link
     this.attestItem = item;
     this.onAttest = true;
   },

   async attestConfirmation(value){
     //compensate for passed array data
     let passedData = value.data[0]


     let data = {
       training_video_id : passedData.training_videos[0] ? passedData.training_videos[0].ID : 0,
       link: passedData.link,
       date_attested: moment().utc(),
       attested: true,
       training_policy_id: passedData.ID,
       version: passedData.version
     }

     await this.$axios.post("/trainings/users/"+this.$store.state.auth.jwtPayload.user_id+"/attest-policy", data)
       .then((response) => {
           if (response.data.success){
             this.getData();
             this.$toast.success(response.data.message)
           } else {
             this.$toast.error(response.data.message)
           }
       })
       .catch()
   },

   closeAttest() {
     this.onAttest = false;
     this.attestItem = null;
     this.isAttested = false;
   },

  getAttestationTooltip(policy) {
     if (policy.attested.attested)
       return 'Attestation Complete';

     if (!policy.required)
       return 'Attestation Not Required';

     if (!policy.pdf_exists && this.isAdmin){
       return "Policy file is not available. Please re-upload the file"
     } else if (!policy.pdf_exists && !this.isAdmin){
       return "Policy file is not available. Please contact your organisation admin"
     }

     return 'Click to complete attestation';
   },

   openPolicy() {
     this.setForm = true;
   },

   closePolicy(){
     this.setForm = false;
     this.editedPolicy = null;
   },

   truncatedLink(link) {
     const maxLength = 50;


     let truncated = link.substring(0, maxLength);
     if (link.length > maxLength) {
       truncated += '...';
     }

     return truncated;
   },

   handleLinkClick(item) {
     if (!item.pdf_exists) {
       if (this.isAdmin)
         this.$toast.warning("A new policy upload is required due to error with existing file.")
       else
         this.$toast.warning("A new policy upload is required due to error with existing file.")

       return
     }

     if (!item.link) {
       return
     }

     if (!item.link.includes("http")) {
       this.openLinkInNewTab("https://" + item.link);
     } else {
       this.openLinkInNewTab(item.link);
     }
   },

   getTooltipContent(videoID) {
     // Check if the videoID exists in the select options
     const videoExists = this.videoIDs.some(video => video.value === videoID);

     return videoExists;
   },

   openLinkInNewTab(link) {
     window.open(link, '_blank');
   },

   previousPage() {
     this.pagination.page > 1 ? this.pagination.page -= 1 : ''
   },

   nextPage() {
     this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : ''
   },
 },

 computed: {
   filteredHeaders() {
     return this.headers.filter(header => header.show === undefined || header.show);
   },

   updatedHeaders() {
     return this.headers.map(header => ({
       ...header,
       show: !(this.isSuperAdmin && (header.value === "attest" || header.value === "attestationDate" || header.value === "attestationStatus")) && (this.isAdmin || this.isSuperAdmin || header.show),
     }));
   },

   organisation() {
     return this.$store.state.auth.isSuperAdmin ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation;
   },

   paginationLabel() {
     var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
     var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)

     return start + " - " + end
   },

   currentPage() {
     return this.pagination.page
   },

   rowsPerPage() {
     return this.pagination.pageSize
   },

   selectedSort: {
     get() {
       return this.sortBy.field + '_' + this.sortBy.order;
     },
     set(value) {
       const [field, order] = value.split('_');
       this.sortBy = { field, order };
     }
   },

   sortItems() {
     return this.sortBy
   },

   filteredSortByList() {
     return this.sortByList.filter(option => {
       if ((option.value === 'attested_desc' || option.value === 'attested_asc') && this.isSuperAdmin) {
         return false;
       }
       return option.show;
     });
   }

 },

 watch: {
   search: debounce(function() {
     this.policies = []
     this.pagination.page = 1
     this.getData()
   }, 600),

   organisation(){
     if (this.$store.state.auth.accessToken == null) return
     this.orgID = this.$store.state.user.organisation.id
     this.init();
   },

   sortItems() {
     this.init();
   },

   currentPage() {
     this.init()
   },

   rowsPerPage() {
     this.pagination.page = 1
     this.init()
   },
 }
}
</script>


<style scoped>
.form-control{
 -webkit-border-radius: 0px;
    -moz-border-radius: 20px;
         border-radius: 20px;
}
.btn-create {
 -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
         border-radius: 20px;
 font-size:13px;
 font-weight: 900;
 padding-right: 15px;
 padding-left: 15px;
 margin-bottom: 0px;
}

.btn-square {
 -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
         border-radius: 0px;
 border:1px solid #00A0C1;
}

::-webkit-input-placeholder {
  font-size: 14px!important;
}

:-moz-placeholder { /* Firefox 18- */
     font-size: 14px!important;
}
::-moz-placeholder {  /* Firefox 19+ */
     font-size: 14px!important;
}

/* Container holding the image and the text */
.container {
 position: relative;
 text-align: center;
 color: white;
}
.styled-checkbox {
   position: relative;
   width: 25px;
   height: 25px;
 }

 .styled-checkbox input {
   position: absolute;
   opacity: 0;
   cursor: pointer;
 }

 .styled-checkbox label {
   position: absolute;
   top: 0;
   left: 0;
   width: 25px;
   height: 25px;
   background-color: transparent;
   border: 2px solid #6c757d;
   border-radius: 1px;
 }

 .styled-checkbox input:checked + label {
   border-color: #198754;
 }

 .styled-checkbox input:checked + label::before {
   content: '\2713'; /* Unicode checkmark character */
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   font-size: 16px;
   color: #198754;
   font-weight: bold;
 }

 .table-select {
  padding-left: 5px;
  margin-right: 0;
  cursor: pointer;
  border: none;
  height: 45px;
  width: auto;
 }

 .table-select:not(.high, .low, .medium) {
   color: #435666;
 }

 .table-select>option{
   color: #212529;
 }

 .table-select:not(:hover) {
   background: none;
 }

 /* attest button */
 .custom-icon-btn {
   align-items: center;
   justify-content: center;
   padding: 0;
   border-radius: 50%;
 }

 .custom-icon-btn svg {
   width: 18px;
   height: 18px;
 }

 .btn-circle-inactive{
 color: #bebebe;
 width: 30px;
 height: 30px;
 padding: 6px 0px;
 border-radius: 15px;
 text-align: center;
 font-size: 12px;
 line-height: 1.42857;
 border: 1px solid #bebebe;
}

.btn-circle-active{
 color: #00B972;
 width: 30px;
 height: 30px;
 padding: 6px 0px;
 border-radius: 15px;
 text-align: center;
 font-size: 12px;
 line-height: 1.42857;
 border: 1px solid #00B972;
}
.btn-circle-pending{
 color: #ffc107;
 width: 30px;
 height: 30px;
 padding: 6px 0px;
 border-radius: 15px;
 text-align: center;
 font-size: 12px;
 line-height: 1.42857;
 border: 1px solid #ffc107;
}

/* attest button */


/* Bottom right text */
.overlay-top {
 background:#605f5f77;
 position: absolute;
 top: 0%;
 width:100%;
 height:20%;
 font-size:14px;
 overflow:visible;
}

/* Additional styling for the warning icon */
.warning-icon {
 position: absolute;
 top: 0;
 right: 0;
 background: orange;
 color: white;
 border-radius: 50%;
 padding: 0.2rem;
 font-size: 0.8rem;
}

/* Optional: Position the warning icon to make it look like a badge */
.btn {
 position: relative;
}

/* Optional: Adjust spacing and size as needed */
.btn-circle {
 padding: 0.5rem;
 border-radius: 50%;
}

.custom-icon-btn i {
 font-size: 1.5rem;
}
</style>